export default {
  props: {
    type: {
      type: String,
      default: 'default',
    },
    label: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    margin: {
      type: String,
      default: 'yes',
    },
    message: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      required: false,
      default: '',
    },
    height: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    buttonAddIcon() {
      switch (this.icon) {
        case 'cross':
          return 'fas fa-times'
        case 'arrow':
          return 'ti-arrow-right'
        case 'quote':
          return 'fa fa-file'
        case 'outline_info':
          return 'fas fa-envelope'
        case 'outline_success':
          return 'fas fa-file-signature'
        case 'sign':
          return 'fas fa-pen-alt'
        case 'modify':
          return 'fa fa-lg fa-pencil-alt'
        case 'add':
          return 'fa fa-lg fa-plus'
        case 'trash':
          return 'fas fa-trash'
        case 'generate':
          return 'fa fa-cog'
        case 'search':
          return 'ti-search'
        case 'show':
          return 'fas fa-search'
        case 'calendar':
          return 'fas fa-calendar-check'
        case 'download':
          return 'ti-file'
        case 'calculator':
          return 'fas fa-calculator'
        case 'check':
          return 'fas fa-check'
        case 'refresh':
          return 'fa fa-refresh'
        case 'mail':
          return 'fas fa-mail-bulk'
        case 'euro':
          return 'fa fa-lg fa-euro'
        default:
          return ''
      }
    },
    iconLeft() {
      return !!this.icon && !['outline_info', 'outline_success'].includes(this.icon)
    },
    iconRight() {
      return !!this.icon && ['outline_info', 'outline_success'].includes(this.icon)
    },
    iconClasses() {
      return 'd-flex justify-content-center align-items-center'
    },
    buttonClasses() {
      return {
        btn: true,
        'btn-default': this.type === 'default',
        'btn-addon font-weight-bold': this.type === 'information',
        'btn-primary': ['validation', 'download', 'input', 'show'].includes(this.type),
        'btn-info': ['action', 'info'].includes(this.type),
        'btn-input': this.type == 'input',
        'btn-danger': this.type === 'danger',
        'btn-primary btn-round small': this.type === 'add',
        'btn-primary dropbox-button': this.type === 'drop_add' || this.type === 'drop_modify',
        'btn-outline-info sign-outline-info': this.type === 'outline_info',
        'btn-outline-warning sign-outline-warning': this.type === 'outline_warning',
        'btn-outline-success sign-outline-success': this.type === 'outline_success',
        'btn-secondary': this.type === 'secondary',
        'btn-success': this.type === 'success',
        'btn-warning': this.type === 'warning',
        'btn-link': this.type === 'link',
        'btn-label':
          !!this.buttonAddIcon && this.type !== 'add' && !!this.label && this.type !== 'link' && !this.loading,
        'btn-sm': this.size === 'small',
        'btn-lg': this.size === 'large',
        'mt-10 mr-3': this.margin === 'yes' && this.type !== 'input',
        'r-0': this.margin === 'no_mr',
        'l-0': this.margin === 'no_ml',
        'w-100': this.width === 'full',
        'h-100': this.height === 'full',
        disabled: this.type === 'disabled',
        'd-flex justify-content-center align-items-center': this.width === 'aligned',
        'btn-gray': this.type === 'gray',
      }
    },
  },
}
